import { colors } from 'style'
import styled from 'styled-components'

export const SignInContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, ${colors.dark8}, ${colors.dark6});
  .signin-wrapper {
    width: 100%;
    height: fit-content;
    max-width: 400px;
    background: white;
    padding: 18px;
    border-radius: 6px;
    h4 {
      color: ${colors.blueDark};
    }
    input {
      width: 100%;
      height: 50px;
      padding: 12px;
      border: 1px solid ${colors.border};
      border-radius: 2px;
      margin-bottom: 10px;
    }
    .error {
      color: red;
    }
    .or {
      display: flex;
      position: relative;
      height: 28px;
      margin-top: 8px;
      margin-bottom: 8px;
      justify-content: center;
      .line {
        position: absolute;
        width: 100%;
        height: 1px;
        background: ${colors.dark4};
        top: 14px;
      }
      span {
        color: ${colors.dark4};
        background: white;
        width: 40px;
        z-index: 1;
        text-align: center;
        font-size: 14px;
        margin-top: 2px;
      }
    }
    .btn {
      width: 100%;
      color: white;
      height: 44px;
      letter-spacing: 1px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      text-transform: uppercase;
      box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
      -webkit-box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
      -moz-box-shadow: 8px 7px 17px -9px rgba(0, 0, 0, 0.41);
    }
    .btn-signin {
      margin-top: 10px;
      background: ${colors.blueDark};
    }
    .btn-facebook {
      background: #4267b2;
      margin-bottom: 12px;
      display: flex;
      justify-content: center;
      position: relative;
      i {
        position: absolute;
        left: 18px;
        top: 14px;
      }
    }
    .btn-google {
      background: #4285f4;
      display: flex;
      justify-content: center;
      position: relative;
      i {
        position: absolute;
        left: 18px;
        top: 14px;
      }
    }
    .forgot-password {
      justify-content: center;
      display: flex;
      padding: 30px;
      a {
        color: ${colors.dark6};
        text-decoration: underline;
      }
    }
  }
`
